module.exports = __webpack_public_path__ + "fonts/andale-mono-mtpro-bold.woff2";